<template>
  <el-container style="padding-top:60px">
    <el-header class="indexHeader">
      <el-row :gutter="20">
        <el-col :span="4">
          <div @click="funHome" class="grid-content bg-purple" style="cursor:pointer;line-height:75px;">
            <!-- <span
              style="margin-right: 1px;font-size:18px;font-weight:700;"
              class="el-icon-share logo Background"
            ></span>
            {{webTitle}} -->
            <img src="@/assets/epmTitle.png" style="width:100%;" alt="">
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple-light">
            <titleBar v-if="$route.path" @subItem="subItem"></titleBar>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-dropdown>
              <span class="el-dropdown-link Background">
                <el-badge is-dot :hidden="!needCheckNum || needCheckNum === 0">
                  <el-avatar class="avater" :src="currentUser.avatar" @error="() => true">
                    <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"/>
                  </el-avatar>
                </el-badge>
                {{ currentUserName }}
                <i class="el-icon-arrow-down el-icon--right"/>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="funChangeCompany">切换公司</div>
                </el-dropdown-item>
                <el-dropdown-item
                  divided
                  @click.native.prevent="$router.push('/my-workbench/PersonalCenter')"
                >
                  个人中心
                </el-dropdown-item>
                <el-dropdown-item divided v-if="$_has('w-audit')">
                  <div style="display: flex; align-items: center" @click="$router.push('/my-workbench/AuditItems')">
                    审核事项
                    <el-badge
                      :hidden="!needCheckNum || needCheckNum === 0"
                      style="margin-left: 3px;display: flex;align-items: center"
                      class="mark"
                      :value="needCheckNum"
                    />
                  </div>
                </el-dropdown-item>
                <el-dropdown-item divided>
                  <div @click="quit()">退出系统</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-container>
      <!-- <el-header class="crumb" v-if="!menuItem.secondHide"> -->
      <el-header class="crumb" v-if="false">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple"></div>
          </el-col>
          <el-col :span="18">
            <div class="grid-content bg-purple"></div>
          </el-col>
        </el-row>
        <div class="menuitem">
          <ul>
            <!-- <li @click="clickCategory(index)" :class="{active:categoryIndex==index}" v-for="menu in menuItem.children" :key="menu.id"> -->
            <!-- <li v-for="menu in menuItem.children" :key="menu.id"> -->
            <li v-for="(menu, index) in menuItem.children" :key="menu.id">
              <!-- {{menu.name}} -->
              <!-- <el-link
                :key="menu.id"
                :data="menu"
                :index="'/' + menu.mask"
                :route="'/' + menu.href"
                :underline="false"
                :class="index==liselected?'liselected':''"
                @click="addColor(index)"
                :href="'/' + menu.href"
              >{{menu.name}}</el-link>-->
              <router-link
                :key="menu.id"
                :data="menu"
                :index="'/' + menu.mask"
                :route="'/' + (menu.id ? menu.id : menu.href)"
                :underline="false"
                :class="index == liselected ? 'liselected' : ''"
                @click="addColor(index)"
                :to="'/' + menu.id"
              >
                {{ menu.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </el-header>
      <el-main class="el-main">
        <!-- 主界面 -->
        <template v-if="$route.path == '/'">
          <dataview/>
        </template>
        <template v-else>
          <!--          <keep-alive>-->
          <!--            <router-view v-if="$route.meta.keepAlive"></router-view>-->
          <!--          </keep-alive>-->
          <!--          <router-view v-if="!$route.meta.keepAlive"></router-view>-->
          <router-view></router-view>
        </template>
        <el-backtop></el-backtop>
      </el-main>
    </el-container>

    <dialog-panel :title="companyBoardTitle" :dialogController="companyBoard" width="500px"
                  @cancel="companyBoard = false"
                  :showCancel="false" :showConfirm="false">
      <template v-for="(column, cIndex) in companyColumns">
        <div :key="cIndex" style="display:inline-block;margin:5px 10px">
          <i class="el-icon-office-building"
             :style="{ color: column.id === currentUser.companyId ? '#aaa' : '#409EFF' }"></i>
          <el-button @click.native="checkCompany(column.id)" type="text" :disabled="column.id === currentUser.companyId"
                     v-preventReClick>{{ column.name }}
          </el-button>
        </div>
      </template>
    </dialog-panel>
  </el-container>
</template>

<script>
import Dataview from "./Dataview"; // 首页
import titleBar from "./components/titleBar";
import * as api from "./layoutAPI"
import {getNeedCheckNum} from "./layoutAPI";

export default {
  data() {
    return {
      routeMenus: window.routeMenus,
      currentUser: JSON.parse(localStorage.getItem("currentUser")), // 当前用户
      currentUserName: '',
      menuItem: '', // 子菜单项
      liselected: -1, // 点击当前背景变色索引
      companyBoardTitle: "选择公司",
      companyBoard: false,
      companyColumns: [],
      needCheckNum: undefined
    }
  },
  created() {
    this.currentUserName = this.currentUser.name;
    // 审核事项数量
    this.getNeedCheckNum()
    this.$EventBus.$on('refreshNeedCheckNum', () => {
      this.getNeedCheckNum()
    })
    // console.log('menu',this.routeMenus);
  },
  methods: {
    getNeedCheckNum() {
      getNeedCheckNum().then(res => {
        if (res.code === 1000 && res.data !== undefined) {
          this.needCheckNum = res.data;
        }
      })
    },
    funChangeCompany() {
      api.getAvailableCompanyList().then((res) => {
        if (res.code === 1000) {
          if (res.data.length > 0) {
            this.companyColumns = res.data
            this.companyBoard = true
          }
        }
      })
    },
    checkCompany(cid) {
      api.changeLoginCompany(cid).then(res => {
        if (res.code === 1000) {
          localStorage.setItem("currentUser", JSON.stringify(res.data))
          localStorage.setItem("jwtToken", res.data.jwtToken)
          localStorage.setItem("permissions", JSON.stringify(res.data.sysPermissionList)) // 菜单权限
          localStorage.setItem("funPermissions", JSON.stringify(res.data.functionAuthority)) // 按钮权限
          localStorage.setItem("projectAuthority", JSON.stringify(res.data.projectAuthority)) // 项目权限
          localStorage.setItem("adminFlag", JSON.stringify(res.data.adminFlag)) // 超级管理员标识
          if (this.$route.query.token) {
            localStorage.setItem("fromMultiportLogin", true)
          }
          this.$router.push({path: '/my-workbench/MyWorkbench', query: {fresh: 1}})
          history.go(0) // 刷新页面

          this.$message.success("切换成功");
        }
      })
      this.companyBoard = false
    },
    funHome() {
      this.$router.push({path: '/my-workbench/MyWorkbench'}) // 跳转我的工作台
    },
    subItem(item) {
      this.liselected = -1 // 点击当前背景变色索引
      this.menuItem = JSON.parse(item)

      // console.log("标题点击", this.menuItem)
    },
    // handleSelect (key, keyPath) {
    //   console.log(key, keyPath)
    // },
    quit() { // 退出系统
      // let fromMultiportLogin=localStorage.getItem('fromMultiportLogin')
      // logoutByJava().then(res => {
      // this.$store.dispatch("delAllViews");
      localStorage.removeItem(this.currentUser.id + 'selectedDate');
      localStorage.removeItem("currentUser");
      localStorage.removeItem("jwtToken");
      // localStorage.removeItem("fromMultiportLogin");

      location.reload();

      // });
    },
    clickcategory(index) { // 这里我们传入一个当前值
      this.categoryIndex = index
    },
    addColor(index) {
      this.liselected = index;
      // console.log(index) //控制台输出
    }
  },
  components: {
    titleBar,
    Dataview
  }
}
</script>

<style scoped lang="scss">
@import "~@/style/theme.scss";

.grid-content > > > .el-badge__content.is-fixed.is-dot {
  right: 12px;
}

.grid-content > > > .el-badge__content.is-fixed {
  top: 20px;
}

.el-main {
  display: block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  overflow: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 1px;
}

.indexHeader {
  width: 100vw;
  min-width: 1350px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}

.el-header,
.el-footer {
  background-color: $maincolor;
  color: #fff;
  text-align: center;
  line-height: 60px;
}

.crumb {
  height: 20px;
  /* border-radius: 5px; */
  /* -moz-border-radius: 5px; */
  /* -webkit-border-radius: 20px; */
  /* box-shadow: 0 0 25px #dcdee2; */
  /* background-size: 100px 100px; */
  /* background-position: 15%; */
  background-color: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  color: black;
}

.logo {
  line-height: 60px;
  padding-right: 5px;
}

/* .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  } */

.menuitem ul {
  list-style: none;
  background-color: beige;
  margin-top: 0px;
}

.menuitem li {
  cursor: pointer;
  float: left;
  text-align: left;
  /* width: 100px; */
  /* background: #ccc; */
  margin-left: 30px;
  line-height: 30px;
}

.router-link {
  color: black;
}

.menuitem a {
  display: block;
  text-align: left;
  height: 30px;
}

.menuitem a:link {
  color: black;
  /* background: #ccc no-repeat 5px 12px; */
  text-decoration: none;
}

.menuitem a:visited {
  text-decoration: underline;
}

.menuitem a:hover {
  color: #3399ff;
  font-weight: bold;
  text-decoration: none;
  /* background: url(arrow_on.gif) #f00 no-repeat 5px 12px; */
}

.liselected {
  color: #3399ff;
}

.el-dropdown-link {
  cursor: pointer;
  /* color: #409EFF; */
}

.avater {
  width: 35px;
  height: 35px;
  margin-right: 6px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue